import React from 'react'
import { formatNumber } from '../../hooks/formatNumber';

const ServicesCategoryModal = ({
  isServicesCategoryOpen,
  toggleServicesCategoryModal,
  mainCategories,
  getSubCategories,
  baseUrl,
  setIsEdit,
}) => {
  return (
    isServicesCategoryOpen && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isServicesCategoryOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              <i
                className="fa-solid fa-circle-xmark fa-xl cursor"
                onClick={() => {
                  toggleServicesCategoryModal();
                  setIsEdit(true);
                }}
              ></i>
              <p
                className="modal-title orderDetails-modalTitle mx-3 fs-3 fw-semibold"
                id="exampleModalLabel"
              >
                Select Category
              </p>
            </div>
            <div className="modal-body orderDetails-modalBody my-3">
              <div className=" d-flex justify-content-evenly flex-wrap gap-3">
                {mainCategories.map((cat) => (
                  <div
                    className="category-card bg-opacity-10 d-flex flex-column justify-content-center align-items-center rounded-4 cursor px-2"
                    key={cat.id}
                    style={{
                      height: "235px",
                      backgroundColor: cat.background_color,
                    }}
                    onClick={() => getSubCategories(cat.slug)}
                  >
                    <div className=" d-flex justify-content-between w-100 ">
                      {cat.types.map((type) =>
                        type.value === true ? (
                          <img
                            key={type.id}
                            src={`${baseUrl}${type.icon_url}`}
                            style={{ width: "30px" }}
                            alt={type.name}
                          />
                        ) : (
                          ""
                        )
                      )}
                    </div>
                    <div className="icon-container d-flex justify-content-center align-items-center">
                      <img src={`${baseUrl}${cat.icon_url}`} alt={cat.name} />
                    </div>
                    <p className="fs-5 fw-semibold my-2"> {cat.name}</p>
                    {cat.price > 0 ? (
                      <p className=" fs-5 fw-semibold my-0">{formatNumber(cat.price)} EGP</p>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ServicesCategoryModal;